/**
 * UC-10 extension: TriggerPolicyAudit (player-initiated compliance audit)
 */
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type {
  IPolicyEnforcement,
  PolicyComplianceAuditResult,
} from '../../domain/ports/IPolicyEnforcement';

export interface TriggerPolicyAuditInput {
  policyId?: string;
}

export interface TriggerPolicyAuditOutput {
  ok: boolean;
  audit?: PolicyComplianceAuditResult;
  error?: string;
}

export interface TriggerPolicyAuditDependencies {
  policyEnforcement: IPolicyEnforcement;
  logger?: IAppLogger;
}

export class TriggerPolicyAuditUseCase {
  constructor(private readonly deps: TriggerPolicyAuditDependencies) {}

  execute(input: TriggerPolicyAuditInput): TriggerPolicyAuditOutput {
    try {
      const audit = this.deps.policyEnforcement.triggerComplianceAudit(input.policyId);

      this.deps.logger?.log('debug', 'policy.audit_triggered', {
        policyId: input.policyId,
        violations: audit.summary.totalViolations,
      });

      return { ok: true, audit };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return { ok: false, error: message };
    }
  }
}